import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import BigTile from './components/AgendaContent/BigTile';
import config from "./Config";
import { dbDateToTimestamp } from './utils/helpers';

const currentConfig = Object.values(config).find((config) => config.theme === customData.childTheme);

import { hideAgenda } from "./utils/helpers";

if (document.body.contains(document.querySelector(".js_react_filter"))) {
  document.querySelectorAll(".js_react_filter").forEach((filter) => {
			const root = ReactDOM.createRoot(filter);
      root.render(
        <App activeSubSite={document.querySelector('.js_react_filter').dataset.cinema.replace(/^./, (str) => str.toUpperCase())} currentConfig={currentConfig} rootElement={filter} />
      );
  });
}

if (document.body.contains(document.querySelector('.js_react_tile'))) {
  document.querySelectorAll('.js_react_tile').forEach((movie, index) => {
    let event = Object.values(JSON.parse(decodeURIComponent(movie.dataset.event)))[0];
    const releaseDate = dbDateToTimestamp(event.dates.release + '0000');
    var temp = document.createElement('div');
    ReactDOM.render(
      <BigTile
        movie={event}
        id={index}
        activeFilterDate={false}
        currentConfig={currentConfig}
        releaseDate={releaseDate}
        handleTagClick={function () {
          return;
        }}
      />,
      temp
    );
    movie.parentNode.replaceChild(temp.firstElementChild, movie);
  });
}

if (document.body.contains(document.querySelector('.js_react_tile--detail-page'))) {
  document.querySelectorAll('.js_react_tile--detail-page').forEach((movie, index) => {
    let event = Object.values(JSON.parse(decodeURIComponent(movie.dataset.event)))[0];
    const releaseDate = dbDateToTimestamp(event.dates.release + '0000');
    var temp = document.createElement('div');
    ReactDOM.render(
      <BigTile
        movie={event}
        id={index}
        detailPage={true}
        activeFilterDate={false}
        currentConfig={currentConfig}
        releaseDate={releaseDate}
        handleTagClick={function () {
          return;
        }}
      />,
      temp
    );
    movie.parentNode.replaceChild(temp.firstElementChild, movie);
  });
}

//import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
